exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-gap .list-group-item[data-v-27a9593f]:first-child,.list-group-gap .list-group-item[data-v-27a9593f]:last-child{border-color:hsla(210,8%,51%,.2);-webkit-box-shadow:0 0 0;box-shadow:0 0 0}.list-group-gap .list-group-item.invalid[data-v-27a9593f]{border-color:#d9534f}.list-group-item[data-v-27a9593f]{border-color:hsla(210,8%,51%,.2);-webkit-box-shadow:0 0 0;box-shadow:0 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27a9593f","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/setting/central-settings/central-setting-form-container.vue
// module id = QARp
// module chunks = 113